/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateEditVideoEditorEditsMutationRequest, CreateEditVideoEditorEditsMutationResponse } from "../models/CreateEditVideoEditorEdits";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createEditVideoEditorEdits } from "../axios/createEditVideoEditorEdits";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createEditVideoEditorEditsMutationKey = () => ["web-app-bff-api", { url: '/video-editor/edits' }] as const

export type CreateEditVideoEditorEditsMutationKey = ReturnType<typeof createEditVideoEditorEditsMutationKey>

export function createEditVideoEditorEditsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createEditVideoEditorEditsMutationKey()
        return mutationOptions<CreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {data: CreateEditVideoEditorEditsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createEditVideoEditorEdits(data, config)
          },
        })

}

/**
 * @summary Create an edit from a source (response includes creator and published platforms)
 * {@link /video-editor/edits}
 */
export function useCreateEditVideoEditorEdits<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {data: CreateEditVideoEditorEditsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateEditVideoEditorEditsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createEditVideoEditorEditsMutationKey()

          const baseOptions = createEditVideoEditorEditsMutationOptions(config) as UseMutationOptions<CreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {data: CreateEditVideoEditorEditsMutationRequest}, TContext>
          

          return useMutation<CreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {data: CreateEditVideoEditorEditsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {data: CreateEditVideoEditorEditsMutationRequest}, TContext>
      
}